import { render } from "./quick-module.vue?vue&type=template&id=36a9ebb7&scoped=true"
import script from "./quick-module.vue?vue&type=script&lang=js"
export * from "./quick-module.vue?vue&type=script&lang=js"

import "./quick-module.vue?vue&type=style&index=0&id=36a9ebb7&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a9ebb7"]])

export default __exports__